export const SUPPORTED_LANGUAGES = ['en', 'fr', 'de', 'es', 'nl'];

export const getSupportLanguageUrl = (langCode = '') => {
  const usedLangCode = SUPPORTED_LANGUAGES.includes(langCode) ? langCode : 'en';
  return `https://help.flipdish.com/${usedLangCode}`;
};
